import { render, staticRenderFns } from "./MenuDitte.vue?vue&type=template&id=549a47af&scoped=true&"
import script from "./MenuDitte.vue?vue&type=script&lang=js&"
export * from "./MenuDitte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549a47af",
  null
  
)

export default component.exports